import React from 'react';

const SettingChartSingle = ({surAndLastName, mail, location, isLast, hapakId, onClick}) => {
    return (
        <div
            onClick={onClick} // Füge hier das onClick-Ereignis hinzu
            className={`flex justify-between w-full hover:cursor-pointer hover:bg-stone-100 rounded-lg px-1 py-4 text-sm ${!isLast ? 'border-b' : ''}`}
        >
            <div className='text-left flex-1'>{surAndLastName}</div>
            <div className='text-left flex-1'>{mail}</div>
            <div className='text-left flex-1'>{location}</div>
            <div className='text-left flex-1'>{hapakId}</div>
        </div>
    );
}

export default SettingChartSingle;
